import styled from '@emotion/styled'
import { colors } from 'ic-snacks'

const RowHeaderContainer = styled.div({
  height: '100%',
  width: '260px',
  display: 'flex',
  flexShrink: 0,
  alignItems: 'center',
  background: colors.WHITE,
  paddingLeft: '30px',
  borderRight: `1px solid ${colors.GRAY_93}`,
})

export default RowHeaderContainer
